/* Password input with show/hide toggle, strength meter and the policy checklist (used by signup, reset and change password). */
import "./account.css";
import { useId, useState } from "react";
import { useI18n } from "../../i18n";
import { Field, Icon, Input } from "../../ui";
import { passwordStrength, RULES } from "./passwordPolicy";

export default function PasswordField({ label, value, onChange, err, testId, autoComplete = "new-password", meter = true, hint }: {
  label: string; value: string; onChange: (v: string) => void; err?: string; testId?: string; autoComplete?: string; meter?: boolean; hint?: string;
}) {
  const { L } = useI18n();
  const id = useId();
  const [show, setShow] = useState(false);
  const s = passwordStrength(value);
  const words = [L("Too short", "قصيرة جدًا"), L("Weak", "ضعيفة"), L("Fair", "مقبولة"), L("Good", "جيدة"), L("Strong", "قوية")];
  return (
    <Field label={label} err={err} htmlFor={id} hint={hint}>
      <div className="affix">
        <Input id={id} type={show ? "text" : "password"} dir="ltr" autoComplete={autoComplete} value={value} bad={!!err} onChange={(e) => onChange(e.target.value)} data-testid={testId} />
        <button type="button" className="end ibtn" aria-label={show ? L("Hide password", "إخفاء كلمة المرور") : L("Show password", "إظهار كلمة المرور")} aria-pressed={show} onClick={() => setShow(!show)} data-testid={testId ? testId + "-toggle" : undefined}>
          <Icon name="eye" />
        </button>
      </div>
      {meter && (
        <>
          <div className={"pw-meter s" + s} role="meter" aria-label={L("Password strength", "قوة كلمة المرور")} aria-valuemin={0} aria-valuemax={4} aria-valuenow={s} aria-valuetext={words[s]} data-testid={testId ? testId + "-meter" : undefined}>
            <i /><i /><i /><i />
          </div>
          <ul className="pw-rules" aria-label={L("Password rules", "شروط كلمة المرور")}>
            {RULES.map((r) => <li key={r.id} className={r.test(value) ? "ok" : ""}>{L(r.en, r.ar)}</li>)}
            {value && <li className={s >= 3 ? "ok" : ""} aria-live="polite">{words[s]}</li>}
          </ul>
        </>
      )}
    </Field>
  );
}
